module.exports = __webpack_public_path__ + "static/server-f51cbcf421dff1aef09be1164b4a12df.jpg";